import { getCustomServerSideProps, GetServerSidePropsContext } from '@/utils/serverSide';

import type { AppNames } from '@/types/pages';

interface Props {
    app: {
        name: AppNames;
    };
    settings: {
        title: string;
        description: string;
    };
}
export const makeServerSideProps = ({ app, settings }: Props) => {
    const getServerSideProps = async (
        context: GetServerSidePropsContext,
    ) => {
        return getCustomServerSideProps(
            context,
            {
                config: {
                    layout: {
                        name: app.name,
                    },
                    protected: false,
                },
            },
            {
                redirectIfLogged: false,
                seoConfig: {
                    title: settings.title,
                    description: settings.description,
                },
            },
        );
    };

    return getServerSideProps;
}
